import { useCallback, useEffect, useState } from 'react';

export const useElementWidth = <T extends HTMLElement = HTMLElement>(selector?: string) => {
	const [width, setWidth] = useState<number>();
	const [node, setNode] = useState<T | null>(null);

	const ref = useCallback((element: T | null) => setNode(element), []);

	useEffect(() => {
		const el = selector ? (document.querySelector(selector) as T | null) : node;
		if (!el) return;

		const measure = () => setWidth(el.offsetWidth);

		measure();

		const observer = new ResizeObserver(measure);
		observer.observe(el);
		window.addEventListener('resize', measure);

		return () => {
			observer.disconnect();
			window.removeEventListener('resize', measure);
		};
	}, [selector, node]);

	return { width, ref };
};
